<template>
    <div>
        <div v-if="!loading" class="home-pag">
          <banner title="আসন বিন্যাস"></banner>
          <section class="event team-sec team-grid speaker set-relative" id="speaker">
            <div class="container">
              <div class="row">
                <div class="col-lg-10 offset-lg-1 col-md-12 speker-container">
                  <div class="d-flex">
                    <!-- <a @click="showT">Click</a> -->
                    <!-- <vue-pdf-app pdf="/cu-pdf/Prospectus.pdf" @pages-rendered="pagesRendered"></vue-pdf-app> -->
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div v-else>
            <loader class="loader"></loader> <br />
        </div>
        <div class="tap-top">
            <div><i v-on:click="topFunction()" class="fa fa-angle-double-up"></i></div>
        </div>
    </div>
</template>

<script>
import Loader from '../Helper/Loader'
import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
import "vue-pdf-app/dist/icons/main.css";
// import Advantage from './Advantage'
// import Contact from './Contact'
// import PageFooter from '../Partial/Footer'
import Banner from '../Partial/Banner'
// import LatestNews from '../Partial/LatestNews'
// import Login from '../Auth/Login'
// import { HOME_PAGE_INFO, REGISTRATION, SEND_CONFIRMATION_CODE, VERIFY_CONFIRMATION_CODE, CLAIM_STUDENT_REQUEST } from '../../const/api'
// import { GET, POST } from '../../utils/Request'

export default {
  name: 'SeatPlan',
  components: { Loader, Banner,VuePdfApp },
  data() {
    return {
        loading: true,
        firstTimeLoad: true,
    }
  },
  computed: {
    isOnHomepage() {
      let routeName = this.$route.name
      return routeName == 'home' ? true : false
    }
  },
  created() {
    this.timeoutForLoading();
  },
  mounted() {   
  },
  methods: {
    pagesRendered(pdfApp) {
      setTimeout(() => (pdfApp.pdfViewer.currentScaleValue = "page-height"));
    },
    goForUrl(url) {
      this.$router.replace(url)
    },
    topFunction() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    },
    timeoutForLoading() {
      if (this.firstTimeLoad) {
        this.$nextTick(() => {
          setTimeout(
            function() {
              this.loading = false
            }.bind(this),
            1000
          )
        })
      }
      this.firstTimeLoad = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loader {
  margin-top: 20%;
}
.pdf-app{
  width:100%;
  height:182.5vh;
}
.d-flex{
  padding:10px;
  margin:10px;
  -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
    box-shadow: 1px 0 15px 2px #c1b3b3;
}
.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid{
  max-width:100%;
}


/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
	 box-sizing: border-box;
}

</style>
